import {type TrackingEvent} from '../types';

export const EnrolmentEvents = {
    // Enquiries
    ENQUIRIES_SEND_FORM_MODAL_VIEW: {
        name: 'enquiries-form-send-modal-view',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
    ENQUIRIES_SEND_FORM_MODAL_SEND_CTA: {
        name: 'enquiries-form-send',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
    ENQUIRIES_ENROLL_FORM_MODAL_VIEW: {
        name: 'enquiries-enrol-modal-view',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
    ENQUIRIES_VIEW_ACTIVITY_MODAL_VIEW: {
        name: 'enquiry-entry-activity-modal-view',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
} satisfies Record<string, TrackingEvent>;
